var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.225,
    height: 312.808,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6034.202 2747.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -2746.811,
    x: 6034.701,
    height: 311.811,
    width: 223.228,
    rx: 10.63,
    ry: 10.63,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.997
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6041.936-2700.745v-2.737h2.66l5.665-29.272h3.223l6.243 29.272h2.148v2.737h-7.318v-2.737h1.977l-.788-4.486h-7.386l-.57 4.486h1.977v2.737zm13.178-10.416l-3.209-15.67-3.006 15.67zM6250.694-2481.066v2.737h-2.661l-5.664 29.272h-3.223l-6.243-29.272h-2.148v-2.737h7.318v2.737h-1.977l.788 4.486h7.385l.57-4.486h-1.976v-2.737zm-13.178 10.416l3.208 15.67 3.007-15.67z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78 61.253c-1.583-3.473-1.757-9.406 2.97-10.208 3.563-.459 5.012 1.198 5.3 3.741.143.744.562.789.695-.058.205-2.61 2.788-4.132 4.807-3.75 5.526.946 5.204 7.029 3.398 11.156-2.73 5.48-5.6 8.937-8.245 14.452-3.038-5.741-6.507-10.405-8.925-15.333zM100.063 127.657c7.144-.474 10.868 5.628 11.595 10.437.433.764.67.548.837-.043.35-6.174 5.875-11.22 10.992-10.53 8.328.108 13.39 9.376 11.967 17.219-1.739 9.582-6.9 15.351-10.808 21.293-4.421 6.152-10.373 15.04-12.29 19.317 0 0-6.048-9.205-13.917-20.03-5.262-7.238-9.473-15.082-9.865-21.835-.448-7.716 2.719-14.632 11.489-15.828zM197.16 251.94c-1.584 3.472-1.757 9.405 2.97 10.208 3.563.458 5.012-1.198 5.3-3.742.143-.743.562-.789.695.058.205 2.61 2.787 4.133 4.807 3.75 5.526-.945 5.204-7.028 3.398-11.155-2.73-5.48-5.6-8.938-8.245-14.452-3.038 5.74-6.507 10.405-8.926 15.333z",
    fill: "#d40000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAh);
export default __webpack_public_path__ + "static/media/AH.ccdab9122bf69bf258784ae232141384.svg";
export { ForwardRef as ReactComponent };